export const GAME_NAMESPACE = "/game";
/** Room names (server side). */
export const rooms = {
    all: "all",
    user: (userId) => `user:${userId}`,
    admins: "admins",
};
//# sourceMappingURL=events.js.map